import { SVGProps } from 'react';

export const SvgLoyalty = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M16.667 9.99935V18.3327H3.33366V9.99935M10.0003 18.3327V5.83268M10.0003 5.83268H6.25033C5.69779 5.83268 5.16789 5.61319 4.77719 5.22249C4.38649 4.83179 4.16699 4.30188 4.16699 3.74935C4.16699 3.19681 4.38649 2.66691 4.77719 2.27621C5.16789 1.88551 5.69779 1.66602 6.25033 1.66602C9.16699 1.66602 10.0003 5.83268 10.0003 5.83268ZM10.0003 5.83268H13.7503C14.3029 5.83268 14.8328 5.61319 15.2235 5.22249C15.6142 4.83179 15.8337 4.30188 15.8337 3.74935C15.8337 3.19681 15.6142 2.66691 15.2235 2.27621C14.8328 1.88551 14.3029 1.66602 13.7503 1.66602C10.8337 1.66602 10.0003 5.83268 10.0003 5.83268ZM1.66699 5.83268H18.3337V9.99935H1.66699V5.83268Z"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
